import { render, staticRenderFns } from "./DialogShare.vue?vue&type=template&id=a583dafe&"
import script from "./DialogShare.vue?vue&type=script&lang=js&"
export * from "./DialogShare.vue?vue&type=script&lang=js&"
import style0 from "./DialogShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports